import { useGoogleLogin } from '@react-oauth/google'
import axios from 'axios'
import { inject } from 'mobx-react'
import moment from 'moment'
// import * as qs from 'qs'
import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import ConfirmButton from '../../components/control/button/confirm_button'
import AppInput1 from '../../components/control/custom_input/app_input1'
import {RESULT_CODE} from '../../config/const'
// import { KAKAO_REDIRECT_URI, KAKAO_REST_API, KAKAO_SECRET, NAVER_CLIENT_ID, NAVER_REDIRECT_URI, NAVER_SECRET, RESULT_CODE } from '../../config/const'
import { Page_settings } from '../../config/page_settings'
import { checkEmail, string } from '../../helper/common'
import strings from '../../lang/strings'

const Login = ({ rootStore, history }) => {
  const context = useContext(Page_settings)

  const saveID = (localStorage.getItem('saveId') ?? 1) == 1

  let [id, setId] = useState(saveID ? (localStorage.getItem('id') ?? '') : '')
  let [pwd, setPwd] = useState(saveID ? (localStorage.getItem('pwd') ?? '') : '')
  let [enabled, setEnabled] = useState(false)
  let [saveId, setSaveId] = useState(saveID)
  let [autoLogin, setAutoLogin] = useState((localStorage.getItem('autoLogin') ?? 1) == 1)
  let [errorMsg, setErrorMsg] = useState('')
  let [errorEmail, setErrorEmail] = useState('')
  let [loginCnt, setLoginCnt] = useState(0)

  // useEffect(() => {
  //   let url = new URL(window.location.href)
  //   const code = url.searchParams.get('code')
  //   const state = url.searchParams.get('state')
  //   if (code === null) return

  //   //naver
  //   if (state === NAVER_SECRET) {
  //     context.post('member/naver_info', { code: code },
  //       response => {
  //         //console.log('-4-', response)
  //         const sns_id = response.id
  //         const email = response.email
  //         const name = response.name
  //         const gender = response.gender === 'F' ? 2 : 1
  //         const birth = moment(new Date(`${response.birthyear}-${response.birthday}`)).format('YYYYMMDD')
  //         const tel = response.mobile.replaceAll('-', '')
  //         login(4, email, '', sns_id, name, gender, birth, tel)
  //       },
  //       true,
  //       err => {
  //         context.showAlert(err.msg)
  //       }
  //     )
  //     return
  //   }

  //   //kakao
  //   const param = {
  //     'grant_type': 'authorization_code',
  //     'client_id': KAKAO_REST_API,
  //     'redirect_uri': KAKAO_REDIRECT_URI,
  //     'code': code,
  //     'client_secret': KAKAO_SECRET,
  //   }
  //   axios.post('https://kauth.kakao.com/oauth/token', qs.stringify(param), {
  //     headers: { 'content-type': 'application/x-www-form-urlencoded;charset=utf-8' }
  //   }).then(response => {
  //     const access_token = response.data.access_token
  //     window.Kakao.Auth.setAccessToken(access_token)
  //     axios.get('https://kapi.kakao.com/v2/user/me', {
  //       headers: {
  //         'Authorization': `Bearer ${access_token}`
  //       }
  //     }).then(response => {
  //       //console.log('-2-', response)
  //       const data = response.data
  //       const prop = data.properties
  //       const sns_id = data.id
  //       const email = prop.account_email
  //       const name = prop.nickname
  //       const gender = prop.gender
  //       const birth = prop.birthday
  //       const tel = prop.phone_number
  //       login(2, email, '', sns_id, name, gender, birth, tel)
  //     })
  //   })
  // }, [])

  useEffect(() => {
    setEnabled(id !== '' && pwd !== '')
    setErrorMsg('')
  }, [pwd])

  useEffect(() => {
    setEnabled(id !== '' && pwd !== '')
    setErrorEmail('')
    setErrorMsg('')
  }, [id])

  useEffect(() => {
    if (loginCnt > 4)
      setErrorMsg(strings.pwd_5_error)
    else if (loginCnt > 0)
      setErrorMsg(strings.login_error)
  }, [loginCnt])

  const handleIdEnter = (e) => {
    if (e.keyCode == 13) {
      document.getElementById('pwd').focus()
    }
  }

  const handlePwdEnter = (e) => {
    if (e.keyCode == 13) {
      document.getElementById('btnLogin').click()
    }
  }

  const handleSubmit = e => {
    if (!enabled) return
    e.preventDefault()
    if (!checkEmail(id)) {
      setErrorEmail(strings.invalid_email)
      return
    }
    login(1, id, pwd)
  }

  const login = (type, id, pwd, sns_id = null, name = null, gender = null, birth = null, tel = null) => {
    context.post('member/signin', { type: type, id: id, pwd: pwd, sns_id: sns_id },
      response => {
        localStorage.setItem('loginType', type)
        localStorage.setItem('id', id)
        localStorage.setItem('pwd', pwd)
        localStorage.setItem('sns_id', sns_id)
        localStorage.setItem('autoLogin', autoLogin ? 1 : 0)
        localStorage.setItem('saveId', saveId ? 1 : 0)
        let mb = response.member
        mb.pwd = pwd
        mb.sns_id = sns_id
        context.login(mb, response.favBj, response.favWinee)
        history.replace('/dashboard')
      },
      true,
      err => {
        if (err.result === RESULT_CODE.USER_WITHDRAW) {
          const reason = err.reason
          return context.showModal(strings.withdraw, string.Format(strings.withdraw_at, reason.email, reason.leave), strings.confirm)
        }
        if (type > 1) {
          history.replace('/signup', { info: { type: type, email: id, sns_id: sns_id, name: name, gender: gender, birth: birth, tel: tel } })
          return
        }
        if (err.result === RESULT_CODE.WRONG_PWD) {

        }
        setLoginCnt(loginCnt + 1)
      }
    )
  }

  // const onSnsLogin = (type) => {
  //   if (type === 2) {
  //     window.Kakao.Auth.authorize({
  //       redirectUri: KAKAO_REDIRECT_URI,
  //       //scope: 'account_email, gender, birthday, phone_number'
  //     })
  //   }
  // }
  // const googleLogin = useGoogleLogin({
  //   onSuccess: response => {
  //     axios.get(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${response.access_token}`).then(response => {
  //       //console.log('-3-', response)
  //       const data = response.data
  //       const sns_id = data.sub
  //       const email = data.email
  //       const name = data.name
  //       login(3, email, '', sns_id, name)
  //     })
  //   }
  // })
  // const NaverLogin = () => {
  //   window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&state=${NAVER_SECRET}&redirect_uri=${NAVER_REDIRECT_URI}`
  // }

  return (
    <React.Fragment>
      <div className='login-container'>
        <form onSubmit={handleSubmit}>
          <div className='fs-32 sm-fs-20 f-b'>{strings.login}</div>
          <div className='d-flex justify-content-center mt-5'>
            <div className='fs-16'>{strings.already_signup}</div>
            <div className='fs-16 f-sb'>
              <a className='login_signup' href={'/signup'}>{strings.signup}</a>{strings.do}
            </div>
          </div>
          <AppInput1 className={'mt-36 sm-mt-20'} errorMsg={errorEmail} placeholder={strings.id} id={'id'} inputType={'text'} value={id} onChange={(v) => { setId(v.target.value) }} onKeyDown={handleIdEnter} autoComplete={'username'} />
          <AppInput1 className={'mt-12'} errorMsg={errorMsg} placeholder={strings.pwd} id={'pwd'} inputType={'password'} value={pwd} onChange={(v) => { setPwd(v.target.value) }} onKeyDown={handlePwdEnter} autoComplete={'current-password'} />
          <div className='d-flex mt-14'>
            <div className='d-flex align-items-center cursor-point' onClick={() => setSaveId(!saveId)}>
              <img className='checkbox' src={saveId ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' />
              <div className='fs-14 color-9e9e9e ml-10'>{strings.remeber_id}</div>
            </div>
            {
              /*
                    <div className='d-flex align-items-center cursor-point ml-20' onClick={() => setAutoLogin(!autoLogin)}>
                     <img className='checkbox' src={autoLogin ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' />
                     <div className='fs-14 color-9e9e9e ml-10'>{strings.auto_login}</div>
                    </div>
              */
            }
          </div>
          <div className='mt-7 sm-mt-14'>
            <a className='mb-30 sm-mb-40 login_signup fs-14 color-9e9e9e float-right' href={'/find/1'}>{strings.find_pwd}</a>
            <a className='mb-30 sm-mb-40 login_signup fs-14 color-9e9e9e float-right' href={'/find/0'}>{strings.find_id}</a>
          </div>
          {loginCnt > 4 && <button type='button' className='btn btn-white fs-15' onClick={() => { history.push('/find/1') }}>{strings.reset_pwd}</button>}
          <ConfirmButton id={'btnLogin'} type={"submit"} enabled={enabled} className={'btn btn-login mt-10 fs-15 '} text={strings.login} />
          {/* <div hidden={true} className='divider mt-20 mb-20' />
          <div hidden={true} className='btn-sns btn-kakao fs-15' onClick={() => onSnsLogin(2)}>
            <img className='sns_icon sns-kakao' src={'/assets/image/s_kakao.png'} alt='' />
            <div>{strings.kakao_login}</div>
          </div>
          <div hidden={true} className='btn-sns btn-naver mt-10 fs-15' onClick={() => NaverLogin()}>
            <img className='sns_icon sns-naver' src={'/assets/image/s_naver.png'} alt='' />
            <div>{strings.naver_login}</div>
          </div>
          <div hidden={true} className='btn-sns btn-google mt-10 fs-15' onClick={() => googleLogin()}>
            <img className='sns_icon sns-google' src={'/assets/image/s_google.png'} alt='' />
            <div>{strings.goggle_login}</div>
          </div> */}
        </form>
      </div>
    </React.Fragment>
  )
}

export default withRouter(inject('rootStore')(Login))
